import { NOOP_TRACKER } from "./tracker.js";
/** How long a call site may be blocked waiting for the vendor before we give up on it. */
export const DEFAULT_EMIT_TIMEOUT_MS = 1000;
/** Adapts the provider-facing tracker into the call-site API. */
export function makeAnalytics(tracker, timeoutMs = DEFAULT_EMIT_TIMEOUT_MS) {
    // Resolves once the vendor call settles or once the budget expires, whichever comes first.
    // The tracker keeps running past the timeout — we simply stop making the caller wait for it.
    // This is also the boundary where analytics stops being able to affect the landing flow:
    // neither a rejected promise nor a synchronous throw reaches the caller.
    const emit = async (event) => {
        let timer;
        try {
            await Promise.race([
                tracker.track(event),
                new Promise((resolve) => {
                    timer = setTimeout(resolve, timeoutMs);
                }),
            ]);
        }
        catch {
            /* a tracker that rejects, or throws before returning, is ignored */
        }
        finally {
            clearTimeout(timer);
        }
    };
    return {
        cookieConsentGranted: (consent) => emit({
            type: "cookieConsentGranted",
            marketing: Boolean(consent.marketing),
            statistics: Boolean(consent.statistics),
        }),
        profileCollectionFinished: (profileData) => emit({
            type: "profileCollectionFinished",
            profileData,
        }),
    };
}
export const NOOP_ANALYTICS = makeAnalytics(NOOP_TRACKER);
